module.exports = __webpack_public_path__ + "img/red.4db6040f.png";